import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { sapGuideSections } from '../data/awsSapGuideData';
import './AWSCloudFundamentalsCourse.css';
import './AWSSapPages.css';

const AWSSAPGuidePage: React.FC = () => {
  const [idx, setIdx] = useState(0);
  const sec = sapGuideSections[idx];

  const go = (i: number) => {
    setIdx(i);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Layout>
      <div className="page-hero">
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 6%' }}>
          <div style={{ fontSize: '0.9rem', color: 'var(--gray-600)', marginBottom: '12px' }}>
            <Link to="/programs" style={{ color: 'var(--blue)' }}>Programs</Link> /{' '}
            <Link to="/aws-sap" style={{ color: 'var(--blue)' }}>AWS Solutions Architect Professional</Link> / SAP Guide
          </div>
          <h1>AWS Solutions Architect Professional (SAP-C02): Study Guide</h1>
          <p>Every exam topic explained from beginner to exam level, with architecture diagrams, comparison tables, exam tips and cheat sheets.</p>
          <div style={{ marginTop: '16px', display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <span className="section-tag">Advanced</span>
            <span className="section-tag">{sapGuideSections.length} sections</span>
            <span className="section-tag orange">Diagram-led</span>
          </div>
        </div>
      </div>

      <div className="cf-nav">
        <div className="cf-nav-inner">
          {sapGuideSections.map((s, i) => (
            <button key={s.id} className={`cf-tab${i === idx ? ' on' : ''}`} onClick={() => go(i)}>
              {s.id}. {s.title.length > 22 ? s.title.slice(0, 20) + '…' : s.title}
            </button>
          ))}
          <Link to="/aws-sap-practice" className="cf-tab" style={{ textDecoration: 'none' }}>📝 Practice →</Link>
        </div>
      </div>

      <div className="cf section" style={{ paddingTop: '20px' }}>
        <div className="cf-body" style={{ maxWidth: '1100px' }}>
          <div className="cf-banner">
            <span className="cf-pill">Section {sec.id}</span>
            <h2>{sec.title}</h2>
            <p>{sec.subtitle}</p>
          </div>
          <div className="cf-chips">
            {sec.nav.map((n) => (
              <a
                key={n.id}
                href={`#${n.id}`}
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById(n.id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
              >
                {n.title.replace(/^\d+\.\s*/, '')}
              </a>
            ))}
          </div>

          <section className="les" key={sec.id}>
            <div dangerouslySetInnerHTML={{ __html: sec.html }} />
          </section>

          <div className="cf-pager">
            <button className="btn btn-outline-blue" disabled={idx === 0} style={{ opacity: idx === 0 ? 0.5 : 1 }} onClick={() => go(idx - 1)}>← Previous</button>
            <span style={{ fontWeight: 700, color: 'var(--gray-600)' }}>Section {idx + 1} of {sapGuideSections.length}</span>
            {idx < sapGuideSections.length - 1 ? (
              <button className="btn btn-blue" onClick={() => go(idx + 1)}>Next →</button>
            ) : (
              <Link to="/aws-sap-practice" className="btn btn-orange">Start practising →</Link>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AWSSAPGuidePage;
